import { render, staticRenderFns } from "./ModuloCrm.vue?vue&type=template&id=130b731e&"
import script from "./ModuloCrm.vue?vue&type=script&lang=js&"
export * from "./ModuloCrm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports